import MiQuinielaPanel from './MiQuinielaPanel';
export default MiQuinielaPanel;
